import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { OrderMaterial } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';
import { FlorderEditMaterialComponent } from '../../florder/florder-edit-material/florder-edit-material.component';

@Component({
  selector: 'app-relocation-edit-material',
  templateUrl: './relocation-edit-material.component.html',
  styleUrls: ['../../florder/florder-edit-material/florder-edit-material.component.scss'],
})
export class RelocationEditMaterialComponent extends FlorderEditMaterialComponent<OrderMaterial> implements OnChanges {

  typeOptions: any[];

  isMobilePortraitScreen$ = LayoutBreakpoints.matches(this.breakpointObserver, LayoutBreakpoints.minimumScreenOrLess);

  constructor(private breakpointObserver: BreakpointObserver) {
    super();
  }

  async ngOnChanges(changes: SimpleChanges) {
    await super.ngOnChanges(changes);
    this.calcTypeOptions();
  }

  calcTypeOptions() {
    this.typeOptions = [
      { id: 'packing', name: 'ORDERS.MATERIAL.LABELS.TYPES.PACKING', disabled: !(this.materialTypes?.packings?.length > 0) },
      { id: 'pallet', name: 'ORDERS.MATERIAL.LABELS.TYPES.PALLET', disabled: !(this.materialTypes?.pallets?.length > 0) },
      { id: 'combination', name: 'ORDERS.MATERIAL.LABELS.TYPES.COMBO', disabled: !(this.materialTypes?.combination?.palletIds?.length > 0) },
    ]
  }
}
